import { FC } from 'react'

interface CaretLeftProps {
  width: number
  height: number
  color?: 'black' | 'grey-500'
}

const CaretLeft: FC<CaretLeftProps> = ({ width, height, color }) => {
  const fillColor = color === 'grey-500' ? '#75787B' : '#212721'

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7072 13.8787C10.0977 14.2692 10.0977 14.9024 9.7072 15.2929C9.31668 15.6834 8.68351 15.6834 8.29299 15.2929L1.7072 8.70714C1.41431 8.41424 1.34108 7.98486 1.48753 7.62373C1.53635 7.50335 1.60957 7.39055 1.7072 7.29292C1.70738 7.29275 1.70755 7.29257 1.70773 7.29239L8.29299 0.707135C8.68351 0.316611 9.31668 0.316611 9.7072 0.707135C10.0977 1.09766 10.0977 1.73082 9.7072 2.12135L3.82852 8.00003L9.7072 13.8787Z"
        fill={fillColor}
      />
    </svg>
  )
}

export default CaretLeft
